// Module
var code = "<ticket-status status=locked title=\"{{ 'app.ticket.status.' + vm.ticket.status + '.locked.title' }}\" body=\"{{ 'app.ticket.status.' + vm.ticket.status + '.locked.body' }}\" body-values=\"{ ticketLockTimeInMinutes: vm.ticketLockTimeInMinutes }\" cta=\"vm.navigateTo('list')\" cta-title=app.tickets.back> </ticket-status> ";
// Exports
var _module_exports = code;;
var path = 'app/components/ticket/partials/ticket.statusLocked.tpl.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;